exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "md-toolbar.pie {\r\n\tbackground-color: #c0c0c0;\r\n\ttop:auto;\r\n\tbottom:0px;\r\n\tleft:auto;\r\n\tposition:fixed;\r\n}\r\n\r\n.app-input-dian-pie {\r\n  font-size: 28px;\r\n  color: #515151;\r\n  text-align:right;\r\n  padding-left: 10px;\r\n}\r\n\r\n\r\n.app-toolbar-filler {\r\n  -webkit-box-flex: 1;\r\n      -ms-flex: 1 1 auto;\r\n          flex: 1 1 auto;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/GIT/Simple2593V5/Ingreso/ng_ingresosimple2593/src/app/components/pie/pie.component.css
// module id = ../../../../../src/app/components/pie/pie.component.css
// module chunks = main